<template>
  <VIcon
    :type="computedType"
    :color="color"
    :fallback="fallback"
    size="large"
  />
</template>

<script>
import VIcon from '@/shared/js/components/core/VIcon'

import { MEDIA_TYPE_ICONS } from '@/shared/js/constants/mediaTypes'

export default {
  name: 'ClippingTypeIcon',

  components: {
    VIcon
  },

  props: {
    type: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: ''
    },

    fallback: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    computedType () {
      const type = this.type

      return MEDIA_TYPE_ICONS[type] || type
    }
  }

}
</script>
